// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { UserRoleScope } from '@app/core/state/logged-user';

interface ScopeFormatRaw {
  [key: string]: string[];
}
/**
 * Returns a list of scopes as a Summary
 * e.g
 *
 */
export function RoleScopesSummary(userDetails: UserRoleScope[]): string[] {
  const scope = userDetails.reduce(
    (acc, item) => {
      const data = acc[item.object_type_name] || [];
      const newData = item.object_name || item.object_id;
      acc[item.object_type_name] = [...data, newData];
      return acc;
    },
    {} as ScopeFormatRaw
  );

  return Object.keys(scope).map(item => `${item} (${scope[item].join(', ')})`);
}



// WEBPACK FOOTER //
// ./src/app/access-management/core/services/role-scopes.helpers.ts